import api from './api'

const AGENT_TOKEN_KEY = 'agent_session_token'

export const agentService = {
  getStoredToken(sessionId) {
    return localStorage.getItem(`${AGENT_TOKEN_KEY}:${sessionId}`)
  },

  storeToken(sessionId, token) {
    if (token && sessionId) localStorage.setItem(`${AGENT_TOKEN_KEY}:${sessionId}`, token)
  },

  async createSession(payload = {}) {
    const { data } = await api.post('/agent/sessions', payload, { skipAuthRedirect: true })
    const routeId = data.public_id || data.id
    if (data.anonymous_token) this.storeToken(routeId, data.anonymous_token)
    return data
  },

  async listSessions(limit = 20) {
    const { data } = await api.get('/agent/sessions', { params: { limit }, skipAuthRedirect: true })
    return data
  },

  async resumeSession(options = {}) {
    const headers = {}
    if (options.anonymousToken) headers['X-Agent-Session-Token'] = options.anonymousToken
    const { data } = await api.get('/agent/sessions/resume', { headers, skipAuthRedirect: true })
    const routeId = data.public_id || data.id
    if (data.anonymous_token) this.storeToken(routeId, data.anonymous_token)
    return data
  },

  async getSession(sessionId) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.get(`/agent/sessions/${sessionId}`, { headers, skipAuthRedirect: true })
    const routeId = data.public_id || data.id
    if (data.anonymous_token) this.storeToken(routeId, data.anonymous_token)
    return data
  },

  async sendMessage(sessionId, message) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.post(`/agent/sessions/${sessionId}/messages`, { message }, { headers, skipAuthRedirect: true })
    return data
  },

  async sendVoiceTurn(sessionId, transcript, audioSeconds = 0) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.post(
      `/agent/sessions/${sessionId}/voice_turn`,
      { transcript, audio_seconds: audioSeconds },
      { headers, skipAuthRedirect: true }
    )
    return data
  },

  async sendSecureInput(sessionId, field, value) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.post(
      `/agent/sessions/${sessionId}/secure_input`,
      { field, value },
      { headers, skipAuthRedirect: true }
    )
    return data
  },

  async importGithubIssue(sessionId, { url, issueRef } = {}) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.post(
      `/agent/sessions/${sessionId}/github_issue`,
      { url, issue_ref: issueRef },
      { headers, skipAuthRedirect: true }
    )
    return data
  },

  async getLiveToken() {
    const { data } = await api.post('/agent/live_token')
    return data
  },

  async getUsage() {
    const { data } = await api.get('/usage')
    return data
  },

  async setGithubContext(sessionId, payload) {
    const headers = this.sessionHeaders(sessionId)
    const { data } = await api.patch(`/agent/sessions/${sessionId}/github_context`, payload, { headers, skipAuthRedirect: true })
    return data
  },

  sessionHeaders(sessionId) {
    const token = this.getStoredToken(sessionId)
    return token ? { 'X-Agent-Session-Token': token } : {}
  },
}

export default agentService
